import sanitizeHtml from "sanitize-html";

compiler('[data-reprocess-shipping-labels-file]', (button) => {
  const buttonOriginalText = button.innerHTML;
  const shippingId = button.dataset.shippingId;
  const csrfToken = document.head.querySelector('meta[name="csrf-token"][content]').content;
  // When a confirmation modal/wizard is also active for an element a needs-confirmation data-attribute will be set
  // These components will set the data-modal-confirmed-persisted attribute when the confirmation was issued
  const needsConfirmation = button.hasAttribute('data-needs-confirmation');
  const DATA_CONFIRMED_ATTRIBUTE = 'data-modal-confirmed-persisted';

  button.addEventListener("click", async function() {
    if(needsConfirmation && !button.hasAttribute(DATA_CONFIRMED_ATTRIBUTE)) {
      // If a confirmation modal/wizard is present we only continue with processing if the confirmed attribute is set
      return;
    }
    button.disabled = true;
    let buttonText = button.dataset.textDuringWait;
    button.innerHTML = "<i class=\"fa-solid fa-spinner fa-spin me-1\"></i>" + sanitizeHtml(buttonText);
    await processLabels();
  });

  async function processLabels() {
    try {
      const response = await fetch(`/tools/delivery/${shippingId}/process_labels`, {
        method: 'PUT',
        headers: {
          'X-CSRF-Token': csrfToken,
          "Content-Type": "application/json"
        }
      })

      let success= false;
      if (response.ok) {
        triggerDownload();
        success = true;
      } else {
        const data = await response.json();
        showResponseAlert(data.message);
      }
      resetButton(success);
    } catch {
      showResponseAlert("An error occurred");
      resetButton(false);
    }
  }

  function triggerDownload() {
    const a = document.createElement("a");
    a.href = `/tools/delivery/downloaded_labels?id=${shippingId}`;
    a.click();
  }

  function resetButton(success) {
    button.disabled = false;
    button.innerHTML = buttonOriginalText;
    button.removeAttribute(DATA_CONFIRMED_ATTRIBUTE);
    if (success) {
      button.classList.add("processed-successfully");
    }
  }

  function showResponseAlert(message) {
    const flashContainer = document.querySelector('.flash-container');
    const alertBox = document.createElement('div');
    alertBox.className = "alert alert-danger alert-dismissible mt-1";
    alertBox.innerHTML = `
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">
        <span aria-hidden="true"></span>
      </button>
      <p class="mb-0">${message}</p>
    `;
    flashContainer.appendChild(alertBox);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
});
